<section class="row" *ngIf="data">
	<ng-content></ng-content>
	<section class="col-21">
		<div class="row heading-section align-items-center"><span class="text-16-bold text-uppercase col-24" dcrHTMLKey="FUND_HOLDINGS_TITLE">Number Of Holdings</span></div>
		<ng-container *ngIf="isSingleStocksView; else mutualFundsView">
			<div class="row fund-holding-container">
				<div class="col-7 text-14 label-container">
					<span class="text-36-bold">{{ numberOfSingleStocks }}</span> <span dcrHTMLKey="FUND_HOLDINGS_STOCKS_LABEL">SINGLE STOCKS</span>
				</div>
				<div *ngIf="numberOfSingleStocks" class="seating-grid">
					<bfa-chart type="grid" [data]="data" [hasFullHeight]="true" [customAttributes]="singleStocksChartAttributes"></bfa-chart>
				</div>
			</div>
			<div class="row fund-holding-container align-items-top">
				<div class="col-7 text-14 label-container">
					<span class="text-36-bold">{{ numberOfFunds }}</span> <span dcrHTMLKey="FUND_HOLDINGS_FUNDS_LABEL">FUNDS</span>
				</div>
				<div *ngIf="numberOfFunds" class="seating-grid">
					<bfa-chart type="grid" [data]="data" [hasFullHeight]="true" [customAttributes]="fundsChartAttributes"></bfa-chart>
				</div>
			</div>
		</ng-container>
		<ng-template #mutualFundsView>
			<div class="row fund-holding-container align-items-top">
				<div class="col-7 text-14 label-container">
					<span class="text-36-bold">{{ numberOfMutualFunds }}</span> <span dcrHTMLKey="FUND_HOLDINGS_MUTUAL_FUNDS_LABEL">MUTUAL FUNDS</span>
				</div>
				<div *ngIf="numberOfMutualFunds" class="seating-grid">
					<bfa-chart type="grid" [data]="data" [hasFullHeight]="true" [customAttributes]="mutualFundsChartAttributes"></bfa-chart>
				</div>
			</div>
			<div class="row fund-holding-container">
				<div class="col-7 text-14 label-container">
					<span class="text-36-bold">{{ numberOfEtfs }}</span> <span dcrHTMLKey="FUND_HOLDINGS_ETFS_LABEL">ETFs</span>
				</div>
				<div *ngIf="numberOfEtfs" class="seating-grid">
					<bfa-chart type="grid" [data]="data" [hasFullHeight]="true" [customAttributes]="etfsChartAttributes"></bfa-chart>
				</div>
			</div>
		</ng-template>
		<div class="row margin-top-10" *ngIf="showReviewHoldingsLink">
			<a class="col-24 cta-link-icon" href="#" [routerLink]="[fundHoldingRoute]" [queryParams]="queryParams" fragment="holdings.table">
				<icon class="text-16" type="chevron-right"></icon> <span class="text-16-bold" dcrHTMLKey="FUND_HOLDINGS_LINK">Review fund holdings</span>
			</a>
		</div>
	</section>
</section>
